import { Component, OnInit, ViewChild, ElementRef, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Usuario } from '../../shared/model/usuario';
import { UsuarioService } from '../../shared/service/usuario/usuario.service';
import { LoginService } from '../../shared/service/login/login.service';
import { SegurancaService } from '../../shared/service/seguranca/seguranca.service';
import { CertificadoService } from '../../shared/service/certificado/certificado.service';
import { UtilService } from '../../shared/service/util/util.service';

declare var $: any;

@Component({
  selector: 'app-alterar-usuario',
  templateUrl: './alterar-usuario.component.html',
  styleUrls: ['./alterar-usuario.component.css'],
  styles: [`
      .error { color: crimson; }
  ` ],
})
export class AlterarUsuarioComponent implements OnInit {

  public usuario : Usuario;
  public usuarioTrocaEmail : Usuario;
  public usuarioBase : Usuario;
  public novoEmail: string;
  public regex : string;
  public descricaoRegex : string;
  
  public confirm : string;
  public errorMessage : string;
  public statusFatores: any = {}; 
  public disabledSalvarSubmit: boolean = false;
  public disabledSalvarSenhaSubmit: boolean = false;
  public disabledAlterarSubmit: boolean = false;

  @ViewChild('formAlterarDados', { static: true }) formAlterarDados;
  @ViewChild('formChangePassword', { static: true }) formChangePassword;
  @ViewChild('alterarEmailForm', { static: true }) alterarEmailForm;
  @ViewChild('closeBtnAlterarDados', { static: true }) closeBtnAlterarDados: ElementRef;
  @ViewChild('closeBtnChangePassword', { static: true }) closeBtnChangePassword: ElementRef;
  @ViewChild('closeBtnAlterarCPF', {static: true}) closeBtnAlterarCPF: ElementRef;

  constructor(
    private usuarioService : UsuarioService,
    private loginService : LoginService,
    private segurancaService : SegurancaService,
    private certificadoService: CertificadoService,
    private route: ActivatedRoute,
    private utilService: UtilService){
  }

  ngOnInit() {
    this.confirm = "";
    this.usuarioBase = this.route.snapshot.data['obterDadosUsuario'];
    this.usuario = {...this.usuarioBase};
    this.novoEmail = this.usuario.email;

    this.obterPoliticaSenhaPadrao();
    this.buscaStatusFatores();
  }

  preparaEmailModal(){
    this.errorMessage = null;
  }

  alterarEmail(){
    if(this.novoEmail==null || this.novoEmail==""){
      this.errorMessage = "Campo Novo e-mail está vazio";
      return;
    }
    
    if (this.novoEmail == this.usuario.email){
      $('#modalAlterarEmail').modal('toggle');
      return;
    }
    this.disabledAlterarSubmit = true;
    var usuarioModificarEmail = {...this.usuario};
    usuarioModificarEmail.email = this.novoEmail;
    usuarioModificarEmail.organizacaoId = JSON.parse(localStorage.getItem("currentUser")).organizacaoId;
    this.usuarioService.solicitarTrocaEmail(usuarioModificarEmail).subscribe(
      res => {
        if(res.code==200) {
          this.utilService.showSuccess(res.message);
          this.resetFormAlterarEmail();
        }else{
          this.disabledAlterarSubmit = false;
          this.errorMessage = res.message;
        }
      },
      err => {
        this.disabledAlterarSubmit = false;
        this.errorMessage = err.message;
      }
    );
  }

  resetFormAlterarEmail(){
    $('#modalAlterarEmail').modal('toggle');
    this.errorMessage = "";
  }

  atualizarSenha() {
    var organizacaoId = JSON.parse(localStorage.getItem("currentUser")).organizacaoId;
    this.disabledSalvarSenhaSubmit = true;

    if(this.confirm == this.usuario.changePassword){
      this.usuarioService.atualizarPropriaSenha(this.usuario,organizacaoId).subscribe(
          _ => {
              this.closeBtnChangePassword.nativeElement.click();
              this.utilService.showSuccess("Senha atualizada com sucesso.");
              this.errorMessage = null;
          },
          err => {
            this.disabledSalvarSenhaSubmit = false;
            this.errorMessage = err.message;
          }
      );
    }else{
      this.disabledSalvarSenhaSubmit = false;
      this.errorMessage = "O campo de nova senha e confirmar nova senha são diferentes";
    }
  }

  atualizar() {
    this.disabledSalvarSubmit = true;
    var organizacaoId = JSON.parse(localStorage.getItem("currentUser")).organizacaoId;
    this.usuarioService.atualizarProprioCadastro(this.usuario,organizacaoId).subscribe(
        _ => {
          this.usuarioBase = {...this.usuario};
          this.closeBtnAlterarDados.nativeElement.click();
          this.closeBtnAlterarCPF.nativeElement.click();
          this.utilService.showSuccess("Cadastro atualizado com sucesso.");
          this.errorMessage = null;
        },
        err => {
          this.disabledSalvarSubmit = false;
          this.errorMessage = err.message;
        }
    );
  }

  resetFormAtualizarDados(){
    this.usuario = {...this.usuarioBase};
    this.errorMessage = null;
  }

  resetFormAtualizarSenha(){
    this.formChangePassword.resetForm();
    this.errorMessage = null;
  }

  obterPoliticaSenhaPadrao() {
    this.segurancaService.obterPoliticaSenha().subscribe(
      res => {
          this.errorMessage = null;
          this.regex = res.regex;
          this.descricaoRegex = res.descricao;
      },
      err => {
          if(err.status === 401 || err.status === 403){
            this.loginService.logout();
          }
          this.errorMessage = err.message;
      }
    );
  }

  buscaStatusFatores() {
      let idUsuario =  this.usuario.id;
      let idOrganizacao = JSON.parse(localStorage.getItem("currentUser")).organizacaoId;

      this.certificadoService.getStatusFatores(idUsuario, idOrganizacao).subscribe(
          res => {
              this.statusFatores = res;
          }
      );
  }

  lowerCase(email: string) {
    if (email !== undefined)
      this.novoEmail = email.toLowerCase();
  }

  recebeMensagemSucesso(mensagem){
    this.utilService.showSuccess(mensagem);
  }
}